import React, { useEffect, useState, useRef, Fragment, useImperativeHandle, forwardRef } from "react";
import EmojiesDrop from "../../../TextEditor/EmojiesDrop";
import { ReactComponent as WhiteRightIMG } from "../../../../assets/images/whiteRightIMG.svg";
import { ReactComponent as ClipIcon } from "../../../../assets/images/ActiveIcon2.svg";
import { ReactComponent as ThreeDots } from "../../../../assets/images/icons/ThreeDots.svg";
import { ReactComponent as ThreeDotsActive } from "../../../../assets/images/icons/ThreeDotsActive.svg";
import Button from "../../../UniversalComponents/DefaultButton";
import { Dialog } from "@mui/material";
import { CUSTMOER_NOTES_ATTACHMENT_DATA_GET, CUSTOMER_DELETE_NOTES_ATTACHMENT } from "../../../../utils/constants";
import { deleteData } from "../../../store/customer/CustomerSocialAddUpdateFunction";
import useRequireAuth from "../../../../utils/useRequireAuth";
import { useDispatch } from "react-redux";
import { pushAlert } from "../../../../utils/alertSlice";
import FloatingElement from "../../../UniversalComponents/FloatingElement";
import { ReactComponent as DownArrow } from "../../../../assets/images/downArrow.svg";
import moment from "moment";
import DatePickerComponent from "../../../UniversalComponents/DatePickerComponent";
// const truncateFileName = (fileName, maxLength = 10) => {
//   if (fileName?.length <= maxLength) {
//     return fileName;
//   }
//   const extension = fileName?.split(".").pop();
//   const baseName = fileName?.substring(0, fileName?.length - extension?.length - 1);
//   return `${baseName.substring(0, maxLength - extension?.length - 4)}...${extension}`;
// };

const CustomerNameNotesEditor = forwardRef(
  (
    {
      initialContent,
      setInitialContent,
      notesSetting,
      notesBody,
      textareaRef,
      handleFileUpload,
      selectedFile,
      hndleCloseNotes,
      // getFileLastName,
      editNoteId,
      downloadFiles,
      addNotes,
      setAddNotes,
      notesData,
      setSelectedFiles,
      refetchNotesData,
      formData,
      selectedOptions,
      handleOptionClick,
      selectedDate,
      setSelectedDate,
      selectedContent,
      setSelectedContent,
    },
    ref
  ) => {
    const [activeFormatting, setActiveFormatting] = useState({
      bold: false,
      underline: false,
      italic: false,
      copy: false,
      foreColor: "#000000",
      fontSize: 3,
      fontName: "Poppins",
      formatblock: "p",
      wordcount: 0,
      charactercount: 0,
    });
    const [content, setContent] = useState(initialContent);
    const [paraHeadOpen, setParaHeadOpen] = useState(false);
    const rgbToHex = (rgb) => {
      const [r, g, b] = rgb.match(/\d+/g);
      const hexR = (+r).toString(16).padStart(2, "0");
      const hexG = (+g).toString(16).padStart(2, "0");
      const hexB = (+b).toString(16).padStart(2, "0");
      return `#${hexR}${hexG}${hexB}`;
    };

    const [viewNotes, setViewNotes] = useState({
      allnotes: false,
      addnotes: false,
    });
    const dispatch = useDispatch();
    const { token } = useRequireAuth();
    const [showEditor, setshowEditor] = useState(false);

    const Editorshow = () => {
      setshowEditor(!showEditor);
    };

    console.log(notesData, "vinaynotesdata");

    const dropdownRef = useRef();
    const to_doRef = useRef(null);
    const dateRef = useRef(null);

    // const [selectedContent, setSelectedContent] = useState("Task");

    const [showViewList, setShowViewList] = useState(false);
    const [DateViewContent, setDateViewContent] = useState(false);
    const [isCustomDateView, setIsCustomDateView] = useState(false);

    const TaskToDoData = [
      { label: "Task", value: "Task" },
      { label: "Deal", value: "Deal" },
      { label: "Lead", value: "Lead" },
      { label: "Job", value: "Job" },
    ];

    const DaysToFollowUp = Array.from({ length: 2 }).map((_, idx) => {
      const actualIndex = idx + 1;
      const date = moment().add(actualIndex, "days");
      const formattedDate = date.format("DD MMM");

      const dayLabel = actualIndex === 1 ? "Tomorrow" : "Day After";

      return {
        label: `${dayLabel} (${formattedDate})`,
        value: dayLabel,
        date: formattedDate,
      };
    });

    console.log(DaysToFollowUp);

    // const [selectedDate, setSelectedDate] = useState("Tomorrow");

    const [isChecked, setIsChecked] = useState(false);

    const handleCheckboxChange = (e) => {
      setIsChecked(e.target.checked);
    };

    const handleSelectContent = (selected) => {
      setSelectedContent(selected?.value); // store only value
      setShowViewList(false);
    };

    const selectedDateOption = DaysToFollowUp.find((item) => item.value === selectedDate);
    console.log(selectedDateOption, "selectedDateOption");

    const handleSelectDate = (selectedOption) => {
      setSelectedDate(selectedOption?.value); // { label, value }
    };

    const handleDateChange = (date) => {
      const formatted = moment(date).format("DD MMM YYYY");
      setSelectedDate(formatted);
      // setIsCustomDateView(false);
    };

    const handleCustomViewClick = () => {
      setDateViewContent(false);
      setIsCustomDateView(true);
    };

    const handleTextData = (event) => {
      const isBold = document.queryCommandState("bold");
      const isItalic = document.queryCommandState("italic");
      const isUnderline = document.queryCommandState("underline");
      const fontSize = document.queryCommandValue("fontSize");
      const fontName = document.queryCommandValue("fontName");
      const foreColor = document.queryCommandValue("foreColor");
      const hexColor = rgbToHex(foreColor);
      let formatblock = document.queryCommandValue("formatblock");

      // if (formatblock === "div" || formatblock === "") {
      //   document.execCommand("formatblock", false, "p");
      //   formatblock = "p";
      // }

      const content = event.target.textContent;
      const words = content
        .trim()
        .split(/\s+/)
        .filter((word) => word?.length > 0);
      setActiveFormatting((prevState) => ({
        ...prevState,
        bold: isBold,
        italic: isItalic,
        underline: isUnderline,
        fontSize: fontSize,
        fontName: fontName,
        foreColor: hexColor,
        formatblock: formatblock,
        wordcount: words?.length,
        charactercount: content?.length,
      }));
    };

    const handleButtonClick2 = (event) => {
      textareaRef.current.focus();
      const elementvalue = event.target.value;

      const button = event.currentTarget.getAttribute("data-styletag");
      document.execCommand(button, false, elementvalue);
      setActiveFormatting((prevState) => ({
        ...prevState,
        [button]: elementvalue ? elementvalue : !prevState[button],
      }));

      if (button === "copy") {
        setTimeout(() => {
          setActiveFormatting((prevState) => ({
            ...prevState,
            copy: false,
          }));
        }, 1000);
      }
    };

    const handleButtonClick = (event) => {
      if (textareaRef?.current) textareaRef.current.focus();

      const elementvalue = event.target.value;
      const button = event.currentTarget.getAttribute("data-styletag");

      console.log("button note COpy", button, elementvalue, document.queryCommandState(button));

      // Detect list state BEFORE toggling
      const isUnorderedActive = document.queryCommandState("insertUnorderedList");
      const isOrderedActive = document.queryCommandState("insertOrderedList");

      // Toggle logic for list buttons
      if (button === "insertUnorderedList") {
        if (isUnorderedActive) {
          document.execCommand("insertUnorderedList", false, null); // toggle off
        } else {
          document.execCommand("insertOrderedList", false, null); // turn off opposite
          document.execCommand("insertUnorderedList", false, null); // turn on
        }
      } else if (button === "insertOrderedList") {
        if (isOrderedActive) {
          document.execCommand("insertOrderedList", false, null); // toggle off
        } else {
          document.execCommand("insertUnorderedList", false, null); // turn off opposite
          document.execCommand("insertOrderedList", false, null); // turn on
        }
      } else {
        // All other formatting buttons (bold, italic, etc.)
        document.execCommand(button, false, elementvalue);
      }

      console.log("button note COpy after", button, elementvalue, document.queryCommandState(button));

      // Re-read active states after toggle
      const isBold = document.queryCommandState("bold");
      const isItalic = document.queryCommandState("italic");
      const isUnderline = document.queryCommandState("underline");
      const isUnordered = document.queryCommandState("insertUnorderedList");
      const isOrdered = document.queryCommandState("insertOrderedList");
      const fontSize = document.queryCommandValue("fontSize");
      const fontName = document.queryCommandValue("fontName");
      const foreColor = document.queryCommandValue("foreColor");
      const hexColor = rgbToHex(foreColor);
      let formatblock = document.queryCommandValue("formatblock");

      setActiveFormatting((prevState) => ({
        ...prevState,
        bold: isBold,
        italic: isItalic,
        underline: isUnderline,
        fontSize: fontSize,
        fontName: fontName,
        foreColor: foreColor,
        formatblock: formatblock,
        insertUnorderedList: isUnordered,
        insertOrderedList: isOrdered,
      }));

      if (button === "copy") {
        setTimeout(() => {
          setActiveFormatting((prevState) => ({
            ...prevState,
            copy: false,
          }));
        }, 1000);
      }
    };

    const handleColorChange = (event) => {
      const newColor = event.target.value;
      textareaRef.current.focus();
      document.execCommand("foreColor", false, newColor);
      setActiveFormatting((prev) => ({
        ...prev,
        foreColor: newColor,
      }));
    };

    const getFileLastName = (filePath) => {
      if (typeof filePath === "string" && filePath.includes("/")) {
        return filePath.split("/").pop();
      } else {
        return filePath;
      }
    };

    const handleParaHead = (value) => {
      textareaRef.current.focus();

      document.execCommand("formatblock", false, value);
      setActiveFormatting((prevState) => ({
        ...prevState,
        formatblock: value,
      }));
      setParaHeadOpen(false);
    };
    useImperativeHandle(ref, () => ({
      clearContent: () => {
        setContent("");
        setInitialContent("");
      },
    }));
    const downloadFile = (file) => {
      const url = URL.createObjectURL(file);
      const a = document.createElement("a");
      a.href = url;
      a.download = file.name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    };

    const resetFile = (newSelectedFiles) => setSelectedFiles(newSelectedFiles ?? []);

    const handleClickDeleteFile = (id) => {
      if (id >= 0 && id < selectedFile.length) {
        resetFile(selectedFile.filter((file, idx) => idx !== id));
      }
    };

    const handleDeleteFileServer = async (id, editNoteId) => {
      console.log(id, "deleteApi");
      const url = `${CUSTOMER_DELETE_NOTES_ATTACHMENT}${id}`;
      try {
        const newSelectedFiles = selectedFile.filter((f) => f.id !== id);
        resetFile(newSelectedFiles);

        const response = await deleteData(url, token);
        if (response?.success || response?.data?.success || response?.data?.status) {
          setViewNotes({ allnotes: true, addnotes: true });
          refetchNotesData();
          dispatch(pushAlert({ message: "File deleted successfully.", type: "success", visible: true }));
        } else {
          dispatch(pushAlert({ message: "File not deleted successfully.", type: "danger", visible: true }));
        }
      } catch (error) {
        dispatch(pushAlert({ message: "Something went wrong", type: "danger", visible: true }));
        console.error("Error deleting file:", error);
      }
    };

    return (
      <Fragment>
        <div className="flex flex-col w-full justify-between border p-2 min-h-0 grow rounded border-transparent focus-within:border-778FA5">
          {/* Editable Text Area */}
          <div
            role="textbox"
            contentEditable={true}
            ref={textareaRef}
            value={formData?.notes_body || ""}
            dangerouslySetInnerHTML={{ __html: formData?.notes_body || "" }}
            className="text-sm w-full notesckeditor focus:ring-0 border min-h-0 grow overflow-y-auto scrollbar-hidden focus:outline-none border-white"
            placeholder="Type Something . . ."
            onKeyUp={handleTextData}
          ></div>

          <div className="flex flex-wrap gap-2 px-4 py-2 relative">
            {selectedOptions?.map((option) => {
              return (
                <span
                  key={option?.value}
                  className="text-white text-xs font-medium px-2 py-1 rounded items-center"
                  style={{ backgroundColor: option?.color_code || "#666" }}
                >
                  {option?.label}
                  {console.log("Selected", option?.label)}
                  <button type="button" className="ml-2 text-white" onClick={() => handleOptionClick(option, true)}>
                    <i className="bi bi-x"></i>
                  </button>
                </span>
              );
            })}
          </div>

          {/* Attachments */}
          {selectedFile?.length > 0 && (
            <div className="flex items-start justify-start flex-wrap gap-2 mt-2 shrink-0">
              {selectedFile.map((file, index) => (
                <div
                  key={index}
                  className="flex items-center justify-start gap-1 border border-D2DAE1 py-1 px-3 rounded-5px max-w-full truncate"
                >
                  <div className="truncate">{file.file_name ? file.file_name : file.attachment}</div>
                  <button
                    type="button"
                    onClick={() =>
                      file?.id ? handleDeleteFileServer(file.id, editNoteId) : handleClickDeleteFile(index)
                    }
                    className="m-1"
                  >
                    <i className="bi bi-x-circle text-red-500"></i>
                  </button>
                </div>
              ))}
            </div>
          )}

          {/* Uncomment for task Create in Notes */}
          {/* <div
            className={`flex items-center gap-2 p-2  mx-1 bg-[#F6F6F6] rounded-md ${isChecked ? "opacity-100" : "opacity-70 cursor-not-allowed"}`}
          >
            <input
              type="checkbox"
              className=" h-4 w-4 rounded border-gray-400 bg-white text-[#767676] focus:ring-0 focus:outline-none cursor-pointer"
              id="to-do-data"
              name="to_do_data"
              onChange={handleCheckboxChange}
              checked={isChecked}
            />
            <div className="flex items-center text-[#383838] font-normal text-base">
              Add
              <div className="relative w-fit ml-2 ">
                <div
                  className="text-[#1D4469] text-base font-medium whitespace-nowrap  flex items-center gap-1 bg-white px-2 py-0.5 rounded-md"
                  ref={to_doRef}
                >
                 
                  <div className="flex items-center gap-2 ">
                    <span className="text-[#1D4469] font-medium">{selectedContent}</span>
                    <div
                      className={` ${isChecked ? "cursor-pointer" : "cursor-not-allowed"}`}
                      onClick={() => {
                        if (!isChecked) return; // Prevent action if checkbox is not checked
                        setShowViewList((prev) => !prev);
                      }}
                    >
                      <DownArrow
                        fill={isChecked === true && showViewList ? "#383838" : "#383838"}
                        className={`transition-transform duration-200 h-3 w-3 rounded-sm  ${isChecked === true && showViewList ? "rotate-180 " : "rotate-0 "}`}
                      />
                    </div>
                  </div>
                </div>

                {isChecked === true && showViewList && (
                  <div className="absolute  mt-1  bg-white shadow border rounded-md ">
                    <PortalList
                      open={showViewList}
                      onClose={() => setShowViewList(false)}
                      containerRef={to_doRef}
                      options={TaskToDoData}
                      selectedOptions={[TaskToDoData.find((opt) => opt.value === selectedContent)]}
                      setSelectedOptions={(selected) => setSelectedContent(selected[0]?.value)}
                      onOptionClick={(selected) => handleSelectContent(selected[0])}
                      size="medium"
                      name="TaskToDoData"
                    />
                  </div>
                )}
              </div>
            </div>

            <div className="flex items-center text-[#383838] text-base font-normal">
              to follow up
              <div className="relative ml-2">
                <div className=" py-1 flex items-center  border border-transparent  h-full rounded-md" ref={dateRef}>
                  <span className=" whitespace-nowrap flex items-center gap-2 bg-white px-2 py-0.5 rounded-md">
                    <span className="text-[#1D4469]  font-medium ">{selectedDateOption?.label || selectedDate}</span>
                    <div
                      className={` ${isChecked ? "cursor-pointer" : "cursor-not-allowed"}`}
                      onClick={() => {
                        if (!isChecked) return; // Prevent action if checkbox is not checked
                        setDateViewContent((prev) => !prev);
                        setIsCustomDateView(false); // close date picker
                      }}
                    >
                      <DownArrow
                        fill={isChecked === true && DateViewContent ? "#383838" : "#383838"}
                        className={`transition-transform duration-200 h-3 w-3 ${isChecked === true && DateViewContent ? "rotate-180" : "rotate-0"}`}
                      />
                    </div>
                  </span>
                </div>

                <div>
                  {isChecked === true && DateViewContent && (
                    <div className="absolute top-full mt-1  shadow border rounded-md z-10">
                      <PortalList
                        open={DateViewContent}
                        onClose={() => setDateViewContent(false)}
                        containerRef={dateRef}
                        options={DaysToFollowUp}
                        selectedOptions={[DaysToFollowUp.find((item) => item.value === selectedDate)]}
                        setSelectedOptions={(selected) => setSelectedDate(selected[0]?.value)}
                        onOptionClick={(selected) => {
                          handleSelectDate(selected[0]);
                          setDateViewContent(false);
                        }}
                        size="medium"
                        name="dateContent"
                        addButton
                        addButtonLabel="Custom Date"
                        addButtonAction={handleCustomViewClick}
                      />
                    </div>
                  )}

                  {isCustomDateView && (
                    <div className="">
                      <DatePickerComponent
                        dateFormat="dd MMM yyyy"
                        placeholderText="DD MM YYYY"
                        showYearDropdown
                        autoOpen
                        showMonthDropdown
                        scrollableYearDropdown
                        border="hidden"
                        onChange={handleDateChange}
                        boxHidden
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div> */}
        </div>

        {showEditor && (
          <div className="flex align-center justify-center">
            <div className="w-full border-ynm border-D2DAE1 bg-F1F6F9 flex align-center px-1">
              <div className="flex items-center">
                {/* <div className="text-xs flex items-center justify-start flex-wrap">
                  <div className=" flex items-start justify-center mx-1">
                    <span className="min-w-16 ">Words : {activeFormatting.wordcount}</span>
                  </div>
                  <div className=" flex items-start justify-center mx-1 ">
                    <div className="min-w-16">Char : {activeFormatting.charactercount}</div>
                  </div>
                </div> */}

                <EmojiesDrop textareaRef={textareaRef} />

                <div className="inline-block text-left relative ml-1">
                  <div>
                    <button
                      type="button"
                      className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 capitalize"
                      onClick={() => setParaHeadOpen(!paraHeadOpen)}
                      aria-expanded={paraHeadOpen}
                      aria-haspopup="true"
                    >
                      {activeFormatting.formatblock || "P"}
                      <i className={`bi bi-${paraHeadOpen ? "caret-up" : "caret-down"} text-gray-400`}></i>
                    </button>
                  </div>

                  {paraHeadOpen && (
                    <FloatingElement>
                      <div
                        className=" rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                        role="menu"
                        aria-orientation="vertical"
                        tabIndex="-1"
                      >
                        <div className="py-1" role="none">
                          <button
                            type="button"
                            className={`text-gray-700 block w-full px-4 py-2 text-left text-sm ${
                              activeFormatting.formatblock === "p" ? "bg-1D4469  text-white" : ""
                            }`}
                            onClick={() => handleParaHead("p")}
                            tabIndex="-1"
                          >
                            Paragraph
                          </button>
                          <button
                            type="button"
                            className={`text-gray-700 block w-full px-4 py-2 text-left text-sm ${
                              activeFormatting.formatblock === "h1" ? "bg-1D4469  text-white" : ""
                            }`}
                            onClick={() => handleParaHead("h1")}
                            tabIndex="-1"
                          >
                            Heading 1
                          </button>
                          <button
                            type="button"
                            className={`text-gray-700 block w-full px-4 py-2 text-left text-sm ${
                              activeFormatting.formatblock === "h2" ? "bg-1D4469  text-white" : ""
                            }`}
                            onClick={() => handleParaHead("h2")}
                            tabIndex="-1"
                          >
                            Heading 2
                          </button>
                          <button
                            type="button"
                            className={`text-gray-700 block w-full px-4 py-2 text-left text-sm ${
                              activeFormatting.formatblock === "h3" ? "bg-1D4469  text-white" : ""
                            }`}
                            onClick={() => handleParaHead("h3")}
                            tabIndex="-1"
                          >
                            Heading 3
                          </button>
                          <button
                            type="button"
                            className={`text-gray-700 block w-full px-4 py-2 text-left text-sm ${
                              activeFormatting.formatblock === "h4" ? "bg-1D4469  text-white" : ""
                            }`}
                            onClick={() => handleParaHead("h4")}
                            tabIndex="-1"
                          >
                            Heading 4
                          </button>
                          <button
                            type="button"
                            className={`text-gray-700 block w-full px-4 py-2 text-left text-sm ${
                              activeFormatting.formatblock === "h5" ? "bg-1D4469  text-white" : ""
                            }`}
                            onClick={() => handleParaHead("h5")}
                            tabIndex="-1"
                          >
                            Heading 5
                          </button>
                          <button
                            type="button"
                            className={`text-gray-700 block w-full px-4 py-2 text-left text-sm ${
                              activeFormatting.formatblock === "h6" ? "bg-1D4469  text-white" : ""
                            }`}
                            onClick={() => handleParaHead("h6")}
                            tabIndex="-1"
                          >
                            Heading 6
                          </button>
                        </div>
                      </div>
                    </FloatingElement>
                  )}
                </div>
                <div className="mx-1">
                  <select
                    className="form-select px-2 rounded-5px text-sm/[1rem] line"
                    data-styletag="fontSize"
                    onChange={handleButtonClick}
                    value={activeFormatting.fontSize}
                  >
                    <option value={"1"}>1</option>
                    <option value={"2"}>2</option>
                    <option value={"3"}>3</option>
                    <option value={"4"}>4</option>
                    <option value={"5"}>5</option>
                    <option value={"6"}>6</option>
                  </select>
                </div>

                <div className="mx-1 relative">
                  <input
                    type="color"
                    id="favcolor"
                    className="color-input w-6 h-6"
                    name="favcolor"
                    value={activeFormatting?.foreColor}
                    onChange={handleColorChange}
                  />
                  <div
                    id="custom-colorbox-1"
                    className="customcolorbox w-7 h-7"
                    style={{ backgroundColor: activeFormatting?.foreColor }}
                  >
                    <i className="bi bi-palette-fill text-1D4469"></i>
                  </div>
                </div>

                <button
                  type="button"
                  className={`mx-1 ${activeFormatting.bold && "text-2999BC bg-EAEAEA rounded"}`}
                  data-styletag="bold"
                  onClick={handleButtonClick}
                >
                  <i className="bi bi-type-bold text-xl text-858f96"></i>
                </button>
                <button
                  type="button"
                  className={`mx-1  ${activeFormatting.underline && "text-2999BC bg-EAEAEA rounded"}`}
                  data-styletag="underline"
                  onClick={handleButtonClick}
                >
                  <i className="bi bi-type-underline text-xl text-858f96"></i>
                </button>
                <button
                  type="button"
                  className={`mx-1  ${activeFormatting.italic && "text-2999BC bg-EAEAEA rounded"}`}
                  data-styletag="italic"
                  onClick={handleButtonClick}
                >
                  <i className="bi bi-type-italic text-xl text-858f96"></i>
                </button>

                <button
                  type="button"
                  className={`px-2 ${activeFormatting.copy ? "text-2999BC bg-EAEAEA rounded" : ""} relative`}
                  data-styletag="copy"
                  onClick={handleButtonClick2}
                >
                  <i className="bi bi-copy text-xl text-858f96"></i>
                  {activeFormatting.copy && (
                    <div className="absolute translate-y-[-60px] translate-x-[-20px] mr-1 p-1 px-2 bg-1D4469 text-white rounded">
                      Copied
                    </div>
                  )}
                </button>

                <button
                  type="button"
                  className={`mx-1 px-1 ${activeFormatting.insertUnorderedList ? "text-2999BC bg-EAEAEA rounded" : ""}`}
                  data-styletag="insertUnorderedList"
                  onClick={handleButtonClick}
                >
                  <i className="bi bi-list-ul text-xl text-858f96"></i>
                </button>

                <button
                  type="button"
                  className={`mx-1 px-1 ${activeFormatting.insertOrderedList ? "text-2999BC bg-EAEAEA rounded" : ""}`}
                  data-styletag="insertOrderedList"
                  onClick={handleButtonClick}
                >
                  <i className="bi bi-list-ol text-xl text-858f96"></i>
                </button>

                <button type="button" className={`mx-1`} data-styletag="undo" onClick={handleButtonClick}>
                  <i className="undo-icon text-858f96"></i>
                </button>
                <button type="button" className={`mx-1`} data-styletag="redo" onClick={handleButtonClick}>
                  <i className="redo-icon text-858f96"></i>
                </button>
              </div>
            </div>
          </div>
        )}
        <div className="flex flex-row w-full justify-start border-t rounded-b-md border-D2DAE1 gap-15px bg-d5dde36b ">
          <div className="flex w-full justify-between ">
            <div className="flex space-x-3">
              <div className="px-2 border-r border-D2DAE1 py-2 flex items-center">
                <button
                  type="button "
                  onClick={(e) => {
                    e.preventDefault();
                    handleFileUpload();
                  }}
                >
                  {/* <i className="bi bi-paperclip text-2xl text-8997A0 rotate-45"></i> */}
                  <ClipIcon className="" />
                </button>
              </div>
              <div className="flex items-center ">
                <span onClick={Editorshow} className="cursor-pointer">
                  {/* <i class="bi bi-three-dots"></i> */}
                  {showEditor ? <ThreeDotsActive /> : <ThreeDots />}
                </span>
              </div>

              {/* <div className="text-xs flex items-center justify-start flex-wrap">
                <div className=" flex items-start justify-center mx-1">
                  <span className="min-w-16 ">Words : {activeFormatting.wordcount}</span>
                </div>
                <div className=" flex items-start justify-center mx-1 ">
                  <div className="min-w-16">Char : {activeFormatting.charactercount}</div>
                </div>
              </div> */}
            </div>
            <div className=" flex p-1 justify-between space-x-2 mr-2">
              <Button
                variant={"secondary"}
                className={"text-sm px-[9px] py-[5px] rounded-lg  "}
                onClick={() => {
                  setAddNotes(false);
                }}
              >
                Cancel
              </Button>
              <Button variant={"primary"} type={"submit"} className={"text-sm px-[9px] py-[5px] rounded-lg "}>
                Submit
              </Button>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
);

export default CustomerNameNotesEditor;
